import { connect } from 'react-redux'
import PanelProgrammes from '../components/programmes/PanelProgrammes'
import {getCats} from '../actions'

const mapStateToProps = (state) => ({
    nameCatok: state.nameCatok,
    permaLien :state.permaLien,
});


const mapDispatchToProps = (dispatch) => ({
    getCats: (x) => dispatch(getCats(x)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PanelProgrammes)